var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "phoneManage" },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c("ul", { staticClass: "phone-manage" }, [
        _c("li", [
          _c("img", {
            attrs: {
              src: require("assets/images/accountCenter/iphone@2x.png"),
              alt: ""
            }
          }),
          _c(
            "div",
            {
              staticClass: "phone-manage__div",
              on: {
                click: function($event) {
                  return _vm.btn_click(1)
                }
              }
            },
            [
              _c("p", [_vm._v("通过原认证手机号换绑")]),
              _c("p", [
                _vm._v(
                  "原绑定手机还在使用，登录账号之后通过接收验证码更换绑定手机"
                )
              ])
            ]
          )
        ]),
        _c("li", [
          _c("img", {
            attrs: {
              src: require("assets/images/accountCenter/light_icon_face@2x.png"),
              alt: ""
            }
          }),
          _c(
            "div",
            {
              staticClass: "phone-manage__div",
              on: {
                click: function($event) {
                  return _vm.btn_click(2)
                }
              }
            },
            [
              _c("p", [_vm._v("通过人脸识别换绑")]),
              _c("p", [
                _vm._v(
                  "原手机号不在使用，登录账号之后通过身份识别快速修改绑定手机"
                )
              ])
            ]
          )
        ]),
        _c("li", [
          _c("img", {
            attrs: {
              src: require("assets/images/accountCenter/light_icon_phone@2x.png"),
              alt: ""
            }
          }),
          _c(
            "div",
            {
              staticClass: "phone-manage__div",
              on: {
                click: function($event) {
                  return _vm.btn_click(3)
                }
              }
            },
            [
              _c("p", [_vm._v("通过人工申诉换绑")]),
              _c("p", [
                _vm._v(
                  "原手机不在使用，并且账号无法登录可以通过提交账号资料人工审核更换绑定手机"
                )
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }